/*
  Better Together — pairing bar (Step 6, escape hatch).
  ==========================================================================
  When a customer clicks "View full details" in the quick view, they land on
  the companion PDP with ?pair={source}&pair_variant={id}&pair_pct={n}. This:
    - persists the pairing to sessionStorage (keyed by THIS/companion handle),
      restores it on same-session revisits, cleans the URL;
    - injects a slim navy bar above the product title reminding them their
      chosen piece is being styled with the source (source thumbnail + text);
    - "Add the pair" adds companion (this PDP's selected size) + source
      (pair_variant), both properties._source='better-together', and refreshes
      the cart the same way the buy box / quick view do;
    - ✕ clears the pairing and removes the bar.
  NOTE: styling suggestion only — no discount is shown or applied anywhere.
  ==========================================================================
*/
(function () {
  if (window.__btPairBar) return;
  window.__btPairBar = true;

  var hook = document.querySelector('[data-bt-pairbar]');
  if (!hook) return;
  var currentHandle = hook.getAttribute('data-current-handle');
  var currentNoun = hook.getAttribute('data-current-noun') || 'item';

  var params = new URLSearchParams(location.search);
  var KEY = 'bt:pair:' + currentHandle;
  var pairing = null;

  if (params.get('pair')) {
    pairing = { source: params.get('pair'), sourceVariant: params.get('pair_variant') || null, pct: parseInt(params.get('pair_pct'), 10) || 0 };
    try { sessionStorage.setItem(KEY, JSON.stringify(pairing)); } catch (e) {}
    // tidy the URL (drop the pair params) without a reload
    try {
      var u = new URL(location.href);
      ['pair', 'pair_variant', 'pair_pct'].forEach(function (k) { u.searchParams.delete(k); });
      history.replaceState({}, '', u.toString());
    } catch (e) {}
  } else {
    try { var s = sessionStorage.getItem(KEY); if (s) pairing = JSON.parse(s); } catch (e) {}
  }
  if (!pairing || !pairing.source) return;

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  fetch('/products/' + encodeURIComponent(pairing.source) + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (src) { buildBar(src); })
    .catch(function () {});

  function buildBar(src) {
    if (document.getElementById('bt-pairbar')) return;
    var bar = document.createElement('div');
    bar.id = 'bt-pairbar';
    var img = src.featured_image || (src.images && src.images[0]) || '';
    bar.innerHTML =
      '<div class="bt-pb-thumb">' + (img ? '<img src="' + esc(img) + '&width=90" alt="">' : '') + '</div>' +
      '<div class="bt-pb-text">Styling this ' + esc(currentNoun) + ' with your <b>' + esc(src.title) + '</b>.</div>' +
      '<button type="button" class="bt-pb-add">Add the pair</button>' +
      '<button type="button" class="bt-pb-x" aria-label="Dismiss">✕</button>';

    var anchor = document.querySelector('.bb-title-block') || document.querySelector('h1.bb-title') ||
      document.querySelector('.product-meta__title') || document.querySelector('.product-item-meta__title');
    if (anchor) {
      var block = anchor.closest('.bb-title-block, .product-meta, .product-item-meta') || anchor;
      block.parentNode.insertBefore(bar, block);
    } else {
      hook.parentNode.insertBefore(bar, hook);
    }

    bar.querySelector('.bt-pb-x').addEventListener('click', function () {
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      bar.remove();
    });
    bar.querySelector('.bt-pb-add').addEventListener('click', function () { addPair(bar); });
  }

  /* current product's selected variant from its own buy box */
  function companionVariantId() {
    var radio = document.querySelector('input[data-bb-size-radio]:checked');
    if (radio) { var lbl = radio.closest('[data-variant-id]'); if (lbl && lbl.getAttribute('data-variant-id')) return lbl.getAttribute('data-variant-id'); }
    var idInput = document.querySelector('form[id^="product-form"] [name="id"], product-form [name="id"]');
    if (idInput && idInput.value) return idInput.value;
    return null;
  }

  function addPair(bar) {
    var btn = bar.querySelector('.bt-pb-add');
    var compVar = companionVariantId();
    if (!compVar) { var t = btn.textContent; btn.textContent = 'Pick a size first'; setTimeout(function () { btn.textContent = t; }, 1800); return; }
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var srcVar = pairing.sourceVariant;
        var srcInCart = srcVar && cart.items.some(function (i) { return String(i.variant_id) === String(srcVar); });
        var items = [{ id: Number(compVar), quantity: 1, properties: { _source: 'better-together' } }];
        if (srcVar && !srcInCart) items.push({ id: Number(srcVar), quantity: 1, properties: { _source: 'better-together' } });
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items, sections: ['mini-cart'] })
        }).then(function (r) { return r.json().then(function (b) { if (!r.ok) throw b; return b; }); });
      })
      .then(function (addRes) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
          .then(function (cart2) {
            if (addRes.sections) cart2.sections = addRes.sections;
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart2, openMiniCart: true } }));
            document.dispatchEvent(new CustomEvent('bb:section-reloaded', { bubbles: true }));
            setTimeout(function () { var d = document.getElementById('mini-cart'); if (d && !d.hasAttribute('open')) { try { d.open = true; } catch (e) { d.setAttribute('open', ''); } } }, 600);
            btn.disabled = false; btn.textContent = 'Added ✓';
          });
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
  }
})();
